// extracted by mini-css-extract-plugin
export default {"policyComponentsTable":"policy-components-table-container__policy-components-table__zfDRk"};